import { useEffect, useMemo } from 'react';
import { Box, CircleButton, RailzCategory, RailzTaxRate, RailzTrackingCategory } from 'vopay';
import { buildTableFormRows, LineItem } from '../buildBillForm.helper';
import { useTranslation } from 'react-i18next';
import { useForm } from '../../../Form/utils';
import { useClientData } from '@/providers/ClientData.provider';
interface BillTableRowProps {
  index: number;
  key: string;
  salesTaxes: RailzTaxRate[];
  trackingCategories: RailzTrackingCategory[];
  categories: RailzCategory[];
  values: LineItem;
  nextRowUpdated: boolean;
  taxCalculation: 'inclusive' | 'exclusive' | 'outOfScope';
  onChange: (index: number, LineItem: LineItem, isValid: boolean) => void;
  onDelete: (index: number) => void;
}

const BillTableRow: React.FC<BillTableRowProps> = ({
  index,
  key,
  salesTaxes,
  trackingCategories,
  categories,
  values,
  nextRowUpdated,
  taxCalculation,
  onChange,
  onDelete,
}) => {
  const { t } = useTranslation('translations');
  const handleDelete = () => {
    onDelete(index);
  };
  const {
    response: { Country },
  } = useClientData();
  const currency = useMemo(() => {
    if (Country === 'US') {
      return 'USD';
    }
    return 'CAD';
  }, [Country]);
  const tableFormRows = buildTableFormRows(salesTaxes, trackingCategories, categories, currency, taxCalculation, t);

  const { renderFormElements, ctx } = useForm<LineItem, LineItem>({
    config: tableFormRows,
    initialValues: values,
    onSubmit: () => {},
  });

  const formElements = renderFormElements({
    config: tableFormRows,
    override(fieldData) {
      return fieldData.template;
    },
  });
  useEffect(() => {
    if (nextRowUpdated) {
      tableFormRows.forEach((element) => {
        if (element.fieldName) {
          ctx.setFieldTouched(element.fieldName, true);
        }
      });
    }
  }, [nextRowUpdated]);

  useEffect(() => {
    if (taxCalculation === 'outOfScope') {
      ctx.setFieldValue('TaxRateID', '');
    }
  }, [taxCalculation]);

  useEffect(() => {
    onChange(index, ctx.values, ctx.isValid);
  }, [ctx.values, ctx.isValid]);

  return (
    <tr key={key}>
      <td>{index + 1}</td>
      <td>{formElements[0]}</td>
      <td>{formElements[1]}</td>
      <td style={{ maxWidth: '56px' }}>{formElements[2]}</td>
      <td style={{ maxWidth: '241px' }}>{formElements[3]}</td>
      {taxCalculation !== 'outOfScope' && <td>{formElements[4]}</td>}
      <td style={{ maxWidth: '56px' }}>{formElements[5]}</td>
      <td>
        <Box gapSize="8px" ai="center">
          {formElements[6]}
          <CircleButton icon="close" iconFill={true} colorScheme="destructive" size="small" onClick={handleDelete} />
        </Box>
      </td>
    </tr>
  );
};

export default BillTableRow;
